export const SERVER_ERROR_MESSAGES = [
  'Failed to fetch',
  'No user found',
  'User with this login already exists',
  'Wagon with this Id not found',
  'Basic wagon not found',
];
